'use client';

import { c as _c } from "react/compiler-runtime";
import { z } from '@repo/schema';
import { useDotEnv } from '@repo/dot-env/client';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { createContext, ReactNode, useContext, useEffect, useRef, useState } from 'react';
import type { ConnectionState, EchoContextValue } from './types';
const EchoContext = createContext<EchoContextValue | null>(null);
export function EchoProvider(t0) {
  const $ = _c(19);
  const {
    accessToken,
    children
  } = t0;
  const env = useDotEnv();
  const [connectionState, setConnectionState] = useState("initialized");
  const [echo, setEcho] = useState(null);
  const accessTokenRef = useRef(accessToken);
  let t1;
  let t2;
  if ($[0] !== accessToken) {
    t1 = () => {
      accessTokenRef.current = accessToken;
    };
    t2 = [accessToken];
    $[0] = accessToken;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== env.BACKEND_URL || $[4] !== env.PUSHER_APP_KEY || $[5] !== env.PUSHER_CLUSTER || $[6] !== env.PUSHER_WS_HOST || $[7] !== env.PUSHER_WS_PORT) {
    t3 = () => {
      if (!env.PUSHER_APP_KEY || !env.PUSHER_WS_HOST || !env.BACKEND_URL) {
        return;
      }
      const instance = new Echo({
        auth: {
          headers: accessTokenRef.current ? {
            Authorization: `Bearer ${accessTokenRef.current}`
          } : {},
          params: {}
        },
        authEndpoint: `${env.BACKEND_URL}/broadcasting/auth`,
        broadcaster: "reverb",
        cluster: env.PUSHER_CLUSTER,
        enabledTransports: ["ws", "wss"],
        forceTLS: false,
        key: env.PUSHER_APP_KEY,
        Pusher,
        wsHost: env.PUSHER_WS_HOST,
        wsPort: env.PUSHER_WS_PORT ? z.coerce.number().parse(env.PUSHER_WS_PORT) : undefined
      });
      setEcho(instance);
      const pusher = instance.connector?.pusher as Pusher | undefined;
      const connection = pusher?.connection;
      if (connection) {
        setConnectionState("connecting");
        connection.bind("connected", () => setConnectionState("connected"));
        connection.bind("disconnected", () => setConnectionState("disconnected"));
        connection.bind("connecting", () => setConnectionState("connecting"));
        connection.bind("unavailable", () => setConnectionState("unavailable"));
        connection.bind("failed", () => setConnectionState("failed"));
      }
      return () => {
        instance.disconnect();
      };
    };
    $[3] = env.BACKEND_URL;
    $[4] = env.PUSHER_APP_KEY;
    $[5] = env.PUSHER_CLUSTER;
    $[6] = env.PUSHER_WS_HOST;
    $[7] = env.PUSHER_WS_PORT;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== accessToken || $[10] !== env) {
    t4 = [env, accessToken];
    $[9] = accessToken;
    $[10] = env;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  useEffect(t3, t4);
  const t5 = connectionState === "connected";
  let t6;
  if ($[12] !== connectionState || $[13] !== echo || $[14] !== t5) {
    t6 = {
      connectionState,
      echo,
      isConnected: t5
    };
    $[12] = connectionState;
    $[13] = echo;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const value = t6;
  let t7;
  if ($[16] !== children || $[17] !== value) {
    t7 = <EchoContext.Provider value={value} data-sentry-element="EchoContext.Provider" data-sentry-component="EchoProvider" data-sentry-source-file="provider.tsx">{children}</EchoContext.Provider>;
    $[16] = children;
    $[17] = value;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}
export function useConnectionState() {
  const $ = _c(3);
  const {
    connectionState,
    isConnected
  } = useEchoContext();
  let t0;
  if ($[0] !== connectionState || $[1] !== isConnected) {
    t0 = {
      connectionState,
      isConnected
    };
    $[0] = connectionState;
    $[1] = isConnected;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
export function useEcho() {
  return useEchoContext().echo;
}
export function useEchoContext() {
  const context = useContext(EchoContext);
  if (!context) {
    throw new Error("useEchoContext must be used within an EchoProvider");
  }
  return context;
}